//TODO : Refactor after ai
/**
 * Environment configuration
 *
 * Centralized access to environment variables with type safety
 */

const apiUrl = (import.meta.env.VITE_API_URL as string | undefined) || "/api";

/**
 * The scheme+host to prefix root-relative asset paths with.
 *
 * Laravel's local disk returns media URLs like `/storage/games/…/cover.png`
 * with no host. Under the dev proxy the base URL is relative, so those already
 * resolve and this stays empty; a production build pointed at an absolute API
 * origin needs the prefix. See `resolveMediaUrl`.
 */
const deriveOrigin = (url: string): string => {
  try {
    return new URL(url).origin;
  } catch {
    // Relative base (e.g. "/api") — same origin as the app.
    return "";
  }
};

export const env = {
  api: {
    // Global prefix only — the `/v1/{actor}` segment lives inside each
    // API_ROUTES path, not in the base URL.
    url: apiUrl,
    origin: deriveOrigin(apiUrl),
    /**
     * The `{actor}` segment of `/v1/{actor}/...`. cubeta-starter generates one
     * route file per actor; `admin` is the only one this backend ships.
     */
    actor: (import.meta.env.VITE_API_ACTOR as string | undefined) || "admin",
    /**
     * Sent as `Accept-Language`. Must be a **bare** code — Laravel's
     * `AcceptedLanguagesMiddleware` compares the raw header against
     * `config('cubeta-starter.available_locales')`, so `en-US,en;q=0.9` misses.
     */
    locale: (import.meta.env.VITE_API_LOCALE as string | undefined) || "de",
    // Prototyp (app-v2): ohne Backend – Mock-Modus ist an, solange er nicht ausdrücklich
    // abgeschaltet wird. So funktioniert jeder Build, egal welches .env der Deploy schreibt.
    useMockData:
      import.meta.env.VITE_USE_MOCK_DATA !== "false" &&
      import.meta.env.VITE_USE_MOCK_DATA !== "0",
  },
  socket: {
    // Empty disables the Socket.IO client. This backend ships no websocket
    // gateway (no Reverb/Echo) — set this only if you add one.
    url: (import.meta.env.VITE_SOCKET_URL as string | undefined) || "",
  },
  sentry: {
    // Leave VITE_SENTRY_DSN empty locally — initSentry() is a no-op when unset
    dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
    environment:
      (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ||
      "development",
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0
    ),
  },
} as const;
